import { LuBadgeCheck, LuClipboardList, LuFlaskConical, LuReceipt } from 'react-icons/lu';
import { PROJECT_DESIGN } from '../../../utils/projectDesign';

// Proje Yönetimi formlarının (Ekle / Düzenle) seçenekleri. Değerler
// Firestore'a olduğu gibi yazılır; yalnızca etiketler çevrilir.

// Tıp dalları kayıtta Türkçe tutulur ve öyle gösterilir (özel ad gibi)
export const DEPARTMENTS = [
  'Acil Tıp', 'Adli Tıp', 'Aile Hekimliği', 'Anesteziyoloji ve Reanimasyon', 'Beyin ve Sinir Cerrahisi',
  'Biyokimya', 'Çocuk Cerrahisi', 'Çocuk Sağlığı ve Hastalıkları', 'Dahiliye', 'Dermatoloji',
  'Enfeksiyon Hastalıkları', 'Fiziksel Tıp ve Rehabilitasyon', 'Gastroenteroloji', 'Göğüs Cerrahisi',
  'Göğüs Hastalıkları', 'Göz Hastalıkları', 'Hematoloji', 'Histoloji ve Embriyoloji', 'İç Hastalıkları',
  'Kadın Hastalıkları ve Doğum', 'Kalp ve Damar Cerrahisi', 'Kardiyoloji', 'Kulak Burun Boğaz (KBB) Hastalıkları',
  'Nefroloji', 'Nöroloji', 'Ortopedi ve Travmatoloji', 'Patoloji', 'Plastik, Rekonstrüktif ve Estetik Cerrahi',
  'Psikiyatri', 'Radyasyon Onkolojisi', 'Radyoloji', 'Spor Hekimliği', 'Tıbbi Biyoloji', 'Tıbbi Farmakoloji',
  'Tıbbi Genetik', 'Tıbbi Mikrobiyoloji', 'Tıbbi Onkoloji', 'Tıbbi Patoloji', 'Üroloji',
].map((name) => ({ value: name, label: name }));

export const CENTER_TYPES = [
  { value: 'Ev', labelKey: 'projectManagement.form.centerTypes.home' },
  { value: 'Hastane', labelKey: 'projectManagement.form.centerTypes.hospital' },
  { value: 'Eş Zamanlı', labelKey: 'projectManagement.form.centerTypes.concurrent' },
];

// Formda seçilebilen aşamalar (eski "Başlangıç / Planlama..." değerleri
// mevcut kayıtlarda kalabilir; formda "(liste dışı)" olarak görünür)
export const FORM_PHASES = [
  { value: 'Faz I', labelKey: 'projectManagement.phases.phase1' },
  { value: 'Faz II', labelKey: 'projectManagement.phases.phase2' },
  { value: 'Faz III', labelKey: 'projectManagement.phases.phase3' },
  { value: 'Düşük Riskli Bilimsel Çalışma', labelKey: 'projectManagement.phases.lowRisk' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/II)', labelKey: 'projectManagement.phases.adaptive12' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz I/III)', labelKey: 'projectManagement.phases.adaptive13' },
  { value: 'Beşeri Tıbbi Ürünlerin Adaptif Tasarımlı Klinik Araştırması (Faz II/III)', labelKey: 'projectManagement.phases.adaptive23' },
  { value: 'Sağlık Beyanlı Ürün/Yöntem Çalışması', labelKey: 'projectManagement.phases.healthClaim' },
  { value: 'Beşeri Tıbbi Ürünlerin Gözlemsel Çalışması', labelKey: 'projectManagement.phases.observational' },
  { value: 'Kök hücreler ile yapılan klinik araştırması', labelKey: 'projectManagement.phases.stemCell' },
];

export const DESIGNS = [
  { value: PROJECT_DESIGN.DOUBLE_BLIND, labelKey: 'projectManagement.designs.doubleBlind' },
  { value: PROJECT_DESIGN.OPEN_LABEL, labelKey: 'projectManagement.designs.openLabel' },
  { value: PROJECT_DESIGN.HYBRID, labelKey: 'projectManagement.designs.hybrid' },
];

// Formun bölümleri, sırasıyla
export const PROJECT_FORM_SECTIONS = [
  { id: 'general', icon: LuClipboardList, tint: 'tw-bg-teal-500/15 tw-text-teal-600 dark:tw-text-teal-300' },
  { id: 'study', icon: LuFlaskConical, tint: 'tw-bg-violet-500/15 tw-text-violet-600 dark:tw-text-violet-300' },
  { id: 'approvals', icon: LuBadgeCheck, tint: 'tw-bg-sky-500/15 tw-text-sky-600 dark:tw-text-sky-300' },
  { id: 'finance', icon: LuReceipt, tint: 'tw-bg-amber-500/15 tw-text-amber-600 dark:tw-text-amber-300' },
];

/** Hata veren alanın bulunduğu bölüm. */
export const FIELD_SECTIONS = {
  customer: 'general',
  titleShort: 'general',
  fixedCurrencyRate: 'finance',
};

// Formun alanları ve boş değerleri (Firestore'a bu alanlar yazılır)
export const EMPTY_PROJECT_FORM = {
  customer: '',
  coordinatorAcademician: '',
  ethicsCommitteeDate: '',
  ethicsCommitteeNumber: '',
  ethicsCommitteePlace: '',
  firstInvoiceDate: '',
  paymentFrequency: '',
  projectCentersType: '',
  projectDate: '',
  projectDepartment: '',
  projectDueDate: '',
  projectPhase: '',
  // Çift kör / open label / hibrit. Hibrit projede primer+blinded çalışanın
  // açtığı vizit unblinded çalışanın takvimine de düşer (utils/hybridVisitMirror.js)
  projectDesign: '',
  protocolNumber: '',
  sbFirstApprovalDate: '',
  sbFirstApprovalNumber: '',
  sbProjectNumber: '',
  titleLong: '',
  titleShort: '',
  center: '',
  isCurrencyFixed: false,
  fixedCurrencyRate: '',
};
